import React from "react";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";
import { project, assets } from "@/config.json";
import { loadImage } from "@/utils";

interface Props {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "locale", "router")
@observer
class FaqContainer extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  state = {
    faq: "",
  };

  componentDidMount() {
    loadImage(assets.faq).then((asset) => {
      this.setState({
        faq: asset.default,
      });
    });
  }

  render() {
    const { locale } = this.props;
    const { faq } = this.state;

    return (
      <div className="Faq-container-page">
        <div className="Faq">{locale.get("login.FAQ")}</div>
        <div className={`list ${`${locale.getLangTypeLowerCase}-list`}`}>
          <div className="center-img">
            <img src={faq}></img>
          </div>
          <div className="box">
            <div className="column">
              <div className="item">
                <span className="title">{locale.get("login.Q1")}</span>
                <div className={`answer answer-${project}`}>
                  <div>
                    {locale.get("login.A1_1")}
                    <br></br>
                    {locale.get("login.A1_2")}
                  </div>
                </div>
              </div>
              <div className="item">
                <span className="title">{locale.get("login.Q2")}</span>
                <div className={`answer answer-${project}`}>
                  <div className="width330">
                    {locale.get("login.A2_1")}
                    <br></br>
                    {locale.get("login.A2_2")}
                    <br></br>
                    {locale.get("login.A2_3")}
                  </div>
                </div>
              </div>
            </div>
            <div className="column">
              <div className="item">
                <span className="title">{locale.get("login.Q3")}</span>
                <div className={`answer answer-${project}`}>
                  <div>{locale.get("login.A3")}</div>
                </div>
              </div>
              <div className="item">
                <span className="title">{locale.get("login.Q4")}</span>
                <div className={`answer answer-${project}`}>
                  <div>{locale.get("login.A4")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FaqContainer as React.ComponentType;
